import { GlobalStateService } from '../global-state/global-state.service';
import { ExcelHelperService } from './excel-helper.service';

let excelHelperService: ExcelHelperService;
let globalStateService: GlobalStateService;
let commandsRegistered = false;

/**
 * Initialize the ExcelHelperService & GlobalStateService reference.
 */
export function initializeSortCommands(
  excelHelper: ExcelHelperService,
  globalState: GlobalStateService
): void {
  excelHelperService = excelHelper;
  globalStateService = globalState;
}

/**
 * Sort selected column A-Z
 */
async function sortAscending(event: Office.AddinCommands.Event): Promise<void> {
  try {
    const selection = await excelHelperService.getSelectedTableColumn();

    if (!selection) {
      console.warn('Please select a cell within a table column');
      event.completed();
      return;
    }

    const password = globalStateService.getWorkpaperContextData().workpaperPassword || '';

    await excelHelperService.sortProtectedTable(
      selection.sheetName,
      selection.tableName,
      selection.columnIndex,
      true, // ascending
      password
    );

    console.log(`Sorted ${selection.columnName} A-Z`);
    event.completed();
  } catch (error) {
    console.error('Error sorting ascending:', error);
    event.completed();
  }
}

/**
 * Sort selected column Z-A
 */
async function sortDescending(
  event: Office.AddinCommands.Event
): Promise<void> {
  try {
    const selection = await excelHelperService.getSelectedTableColumn();

    if (!selection) {
      console.warn('Please select a cell within a table column');
      event.completed();
      return;
    }

    const password = globalStateService.getWorkpaperContextData().workpaperPassword || '';

    await excelHelperService.sortProtectedTable(
      selection.sheetName,
      selection.tableName,
      selection.columnIndex,
      false, // descending
      password
    );

    console.log(`Sorted ${selection.columnName} Z-A`);
    event.completed();
  } catch (error) {
    console.error('Error sorting descending:', error);
    event.completed();
  }
}

/**
 * Register Office.actions immediately when this module loads.
 * This happens before Angular bootstraps.
 */
export function registerSortCommands(): void {
  if (commandsRegistered) {
    return;
  }

  const associateSortActions = (): void => {
    if (commandsRegistered) {
      return;
    }

    if (typeof Office !== 'undefined' && Office.actions) {
      Office.actions.associate('sortAscending', sortAscending);
      Office.actions.associate('sortDescending', sortDescending);
      commandsRegistered = true;
      console.log('Sort commands registered with Office.actions');
      return;
    }

    console.warn('Office.actions not available');
  };

  // Attempt immediate registration for cases where Office is already available.
  associateSortActions();

  // Ensure registration still happens if Office was not ready at import time.
  if (!commandsRegistered && typeof Office !== 'undefined' && typeof Office.onReady === 'function') {
    Office.onReady(() => {
      associateSortActions();
    }).catch((error) => {
      console.error('Failed waiting for Office.onReady while registering sort commands:', error);
    });
  }
}

registerSortCommands();
